import { render, staticRenderFns } from "./SchoolListsAdd.vue?vue&type=template&id=4058e3ae"
import script from "./SchoolListsAdd.vue?vue&type=script&lang=js"
export * from "./SchoolListsAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports